// src/lib/meetingOutcome.js — where a meeting keeps its time, and whether it owes an outcome.
//
// `meetingScheduledAt` moved here from MeetingCountdown.jsx on 2026-09-06 (re-exported there, so
// every importer is unchanged) so that the rule below could be tested under `node --test`
// without bundling a React component. Same body, verbatim.

// THE one place that knows where a meeting keeps its time. Both shapes carry
// `scheduled_at` (core stores it as a column; the legacy feed derives it server-side
// from the newest scheduled/reschedule event), and the events[] fallback keeps rows
// that predate that projection working. Exported so no surface re-derives it.
export function meetingScheduledAt(v) {
  if (!v) return null
  return v.scheduled_at
    || ((v.events || []).find(e => e.kind === 'scheduled' || e.kind === 'reschedule')?.event_at)
    || null
}

// A meeting OWES AN OUTCOME when its hour has passed and the record still says it is going
// to happen — the critical tier of the nudge system, stated as a predicate the card can use.
// Core rows only: a legacy scheduler row opens the old form, which has no reason list, so a
// pill offering one would be a door onto nothing (the same reason the nudges skip them).
// `pending` is not included: it is a resting state with its own follow-up date, and the
// medium nudge sweeps up a stale one; asking "how did it go" of a meeting that already
// answered "we are waiting" would be the wrong question.
// status-subset: `pending` and `binder` are ACTIVE but owe no outcome — see the paragraph above.
export const OUTCOME_OWED_STATUSES = ['scheduled', 'rescheduled']
export function meetingNeedsOutcome(v, now = Date.now()) {
  if (!v?.core_meeting_id) return false
  if (!OUTCOME_OWED_STATUSES.includes(v.status)) return false
  const at = meetingScheduledAt(v)
  if (!at) return false
  const ms = Date.parse(at)
  return Number.isFinite(ms) && ms < now
}
